import { forwardRef, useMemo } from "react";

import { useTheme } from "@mui/material/styles";
import MuiTypography from "@mui/material/Typography";

import { getNestedValueFromPalette } from "../helpers";

import { TypographyProps } from "./types";

import { mergeSx } from "@/helpers/mergeSx";

export const DashboardTypography = forwardRef<HTMLParagraphElement, TypographyProps>(({ vibe, sx, ...rest }, ref) => {
  const theme = useTheme();

  const vibeColor = useMemo(() => {
    if (!vibe) {
      return undefined;
    }

    const textColor = getNestedValueFromPalette(theme.palette, vibe);

    if (!textColor) {
      throw new Error(`Invalid vibe: ${vibe}`);
    }

    return textColor;
  }, [vibe, theme]);

  return <MuiTypography {...rest} ref={ref} sx={mergeSx(vibeColor ? { color: vibeColor } : undefined, sx)} />;
});

DashboardTypography.displayName = "DashboardTypography";
